import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Paper, Button, Container, Card, CardContent } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const TktDashboard = () => {
   // Dummy Data for testing
   const [ticketStats, setTicketStats] = useState({
    totalTickets: 50,
    openTickets: 12,
    closedTickets: 38,
  });

  const [recentTickets, setRecentTickets] = useState([
    { subject: 'Ticket #1', status: 'Open' },
    { subject: 'Ticket #2', status: 'Closed' },
    { subject: 'Ticket #3', status: 'Open' },
  ]);

  const [ticketChartData, setTicketChartData] = useState([
    { date: '2025-01-01', tickets: 5 },
    { date: '2025-01-02', tickets: 10 },
    { date: '2025-01-03', tickets: 7 },
    { date: '2025-01-04', tickets: 3 },
  ]);

  useEffect(() => {
    // Fetch actual data here, if needed, using your API
  }, []);

  // Overview Card Component
  const OverviewCard = ({ title, value, color }) => (
    <Card sx={{ maxWidth: 250, minWidth: 250, marginBottom: 3 }}>
      <CardContent>
        <Typography variant="h6" color="textSecondary">
          {title}
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography variant="h4" fontWeight="bold" sx={{ color }}>
            {value}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  // Recent Tickets Component
  const RecentTickets = ({ tickets }) => (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        Recent Tickets
      </Typography>
      {tickets.map((ticket, index) => (
        <Box key={index} sx={{ marginBottom: 1 }}>
          <Typography variant="body2" color="textSecondary">
            {ticket.subject} - Status: {ticket.status}
          </Typography>
        </Box>
      ))}
    </Paper>
  );

  // Dashboard Chart Component
  const DashboardChart = ({ data }) => (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="tickets" stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );

  return (
    <Container justifyContent="center" sx={{ marginTop: '65px' }}>
      <Grid container spacing={3}>
        {/* Overview Cards */}
        <Grid item xs={12} sm={4} md={4}>
          <OverviewCard title="Total Tickets" value={ticketStats.totalTickets} color="green" />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <OverviewCard title="Open Tickets" value={ticketStats.openTickets} color="red" />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <OverviewCard title="Closed Tickets" value={ticketStats.closedTickets} color="blue" />
        </Grid>

        {/* Recent Tickets */}
        <Grid item xs={12} md={6}>
          <RecentTickets tickets={recentTickets} />
        </Grid>

        {/* Ticket Chart */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ padding: 2 }}>
            <Typography variant="h6" gutterBottom>
              Tickets Over Time
            </Typography>
            <DashboardChart data={ticketChartData} />
          </Paper>
        </Grid>

        {/* Quick Action Buttons */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row' }} mb={3}>
            <Button variant="contained" color="primary" sx={{ marginBottom: { xs: '10px', sm: 0 } }}>
              Create New Ticket
            </Button>
            <Button variant="outlined" color="secondary" sx={{ marginBottom: { xs: '10px', sm: 0 } }}>
              Manage Rooms
            </Button>
            <Button variant="outlined" color="secondary" sx={{ marginBottom: { xs: '10px', sm: 0 } }}>
              Manage Users
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TktDashboard;
